module.exports = __webpack_public_path__ + "static/d2-06f97b9f854c73d4d282cd43e748455d.jpg";